import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import HeaderMMS from '../header/header';
import MenuMMS from '../menu/menu';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#1890ff',
        ...theme.applyStyles('dark', {
          backgroundColor: '#177ddc',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
  },
}));

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function Settings() {
  const [open, setOpen] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const headerProps = {
    open, handleDrawerOpen
  }
  const menuProps = {
    setOpen, open
  }
  const tableProps = {
    setOpenDialog
  }
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));
  return (
    <Box sx={{ display: 'flex' }}>

      <HeaderMMS {...headerProps} />
      <MenuMMS {...menuProps} />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }} className='bg-slate-100'>
        <Grid className='bg-slate-100 '>
          <DrawerHeader />
          {/* <Forms /> */}
          <div className='rounded p-3 text-lg text-left font-semibold'>
            <h2>Email</h2>
          </div>
          <Box className="w-full">
            <Grid className='bg-slate-100 '>
              <form>
                <div className='text-left bg-white  m-2 border-solid border rounded'>
                  <div className='border-slate-300 rounded-md  '>
                    <h3 className='border-b-2  p-3 bg-gray-200 '>Company Details</h3>
                  </div>
                  <Grid item xs={12} md={12} container rowSpacing={3} columnSpacing={2} className='p-3'>
                    <Grid item xs={12} md={9} container columnSpacing={2}>
                      <Grid item xs={12} md={4} >
                        <TextField size='small' label="ID" variant="outlined"
                          name="id"

                          sx={{ width: '100%' }} />
                      </Grid>
                      <Grid item xs={12} md={4} >
                        <TextField size='small' label="Company Name" variant="outlined"
                          name="companyname"

                          sx={{ width: '100%' }} />
                      </Grid>
                      <Grid item xs={12} md={4} >
                        <TextField size='small' label="Contact Name" variant="outlined"
                          name="contactname"

                          sx={{ width: '100%' }} />
                      </Grid>
                      <Grid item xs={12} md={4} >
                        <TextField size='small' label="Email Id" variant="outlined"
                          name="emailid"

                          sx={{ width: '100%' }} />
                      </Grid>
                      <Grid item xs={12} md={4} >
                        <TextField size='small' label="Phone Number" variant="outlined"
                          name="phonenumber"

                          sx={{ width: '100%' }} />
                      </Grid>
                      <Grid item xs={12} md={4} >
                        <Button
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          startIcon={<CloudUploadIcon />}
                        >
                          Logo
                          <VisuallyHiddenInput
                            type="file"
                            onChange={(event) => console.log(event.target.files)}
                            multiple
                          />
                        </Button>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <TextField aria-label="minimum height" sx={{ width: '100%' }} multiline rows={3}
                        label="Address"

                        name='address'

                      />
                    </Grid>


                    

                  </Grid>
                  <div className='border-slate-300 rounded-md  '>
                    <h3 className='border-b-2  p-3 bg-gray-200 '>Workorder Request</h3>
                  </div>
                  <Grid item xs={12} md={12} container rowSpacing={3} columnSpacing={2} className='p-3'>
                  
                      <Grid item xs={12} md={3} >
                        <TextField size='small' label="Workorder Prefix" variant="outlined"
                          name="Workorderprefix"

                          sx={{ width: '100%' }} />
                      </Grid>
                      <Grid item xs={12} md={3} >
                        <TextField size='small' label="Workorder Start No" variant="outlined"
                          name="Workorderstartno"

                          sx={{ width: '100%' }} />
                      </Grid>
                      <Grid item xs={12} md={3} >
                      <TextField size='small' label="Date Format" variant="outlined"
                          name="dateformat"

                          sx={{ width: '100%' }} />
                    </Grid>
                      <Grid item xs={12} md={3} className='flex items-center'>
                      <Typography >Show Permit</Typography>
                      <Stack className='ml-8' direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography>Off</Typography>
        <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
        <Typography>On</Typography>
      </Stack>
                      </Grid>

                      <Grid item xs={12} md={3} className='flex items-center'>
                      <Typography >Show Duration</Typography>
                      <Stack className='ml-8' direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography>Off</Typography>
        <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
        <Typography>On</Typography>
      </Stack>
                      </Grid>
                      <Grid item xs={12} md={3} className='flex items-center'>
                      <Typography >Show Breakdown</Typography>
                      <Stack className='ml-8' direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography>Off</Typography>
        <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
        <Typography>On</Typography>
      </Stack>
                      </Grid>
                      <Grid item xs={12} md={3} className='flex items-center'>
                      <Typography >Show Vendor / Controcter</Typography>
                      <Stack className='ml-8' direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography>Off</Typography>
        <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
        <Typography>On</Typography>
      </Stack>
                      </Grid>
                      <Grid item xs={12} md={3} className='flex items-center'>
                      <Typography >Show Root Case, Action Taken , Special Tools</Typography>
                      <Stack className='ml-8' direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography>Off</Typography>
        <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
        <Typography>On</Typography>
      </Stack>
                      </Grid>
                  
                      <Grid item xs={12} md={3} className='flex items-center'>
                      <Typography >Issued Order</Typography>
                      <Stack className='ml-8' direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography>Off</Typography>
        <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
        <Typography>On</Typography>
      </Stack>
                      </Grid>
                      <Grid item xs={12} md={3} className='flex items-center'>
                      <Typography >Schedulted Order</Typography>
                      <Stack className='ml-8' direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography>Off</Typography>
        <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
        <Typography>On</Typography>
      </Stack>
                      </Grid>

                      <Grid item xs={12} md={3} className='flex items-center'>
                      <Typography >Warrenty Message</Typography>
                      <Stack className='ml-8' direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography>Off</Typography>
        <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
        <Typography>On</Typography>
      </Stack>
                      </Grid>


                  </Grid>
                </div>




              </form>
            </Grid>
          </Box>



        </Grid>
      </Box>
    </Box>
  );

}